import getLocation from './getLocation';

/**
 * Get user country code
 * @param {string} env
 * @returns {Promise<*>}
 */
const getCountryCode = async (env) => {
  try {
    const { country_code: countryCode } = await getLocation(env);

    return countryCode;
  } catch (error) {
    console.error(error);
  }
};

export default getCountryCode;
